// import React, { useEffect, useState, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";

// import Brand from "../components/topBrand/brand";
// import MainSlider from "../components/Banner/MainSlider";
// import KidenyTopRated from "../components/TopRatedComponent/KidenyTopRated";
// import TopUnaniKidneyCareRated from "../components/TopUnaniKidneyCare/TopUnaniKidneyCareRated";
// import Banner from "../components/Banner/Banner";
// import KidneyMedicines from "../components/kidneyMedicines/KidneyMedicines";
// import CustomLoader from "../components/Loader/CustomLoader";

// import { apiGET, apiPOST } from "../utilities/apiHelpers";
// import { setCartCount } from "../redux/users/users";
// import { API_URL } from "../config";

// const Home = () => {
//   const dispatch = useDispatch();
//   const userId = useSelector((state) => state.user?.userData?.id) || "";

//   const [stepperProgressCartData, setStepperProgressCartData] = useState({});
//   const [kidenyTopRatedData, setKidenyTopRatedData] = useState([]);
//   const [brandData, setBrandData] = useState([]);
//   const [productsBasedOnCategoriesData, setProductsBasedOnCategoriesData] =
//     useState([]);
//   const [bannerData, setBannerData] = useState([]);
//   const [kidneyMedicinesData, setKidneyMedicinesData] = useState([]);
//   const [globalConfig, setGlobalConfig] = useState({});
//   const [loading, setLoading] = useState(false);

//   /* ================================
//      USER STEPPER / CART
//   ================================= */
//   const getUserStepperProgress = useCallback(async () => {
//     if (!userId) return;

//     try {
//       const res = await apiGET(
//         `${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`
//       );
//       setStepperProgressCartData(res?.data?.data || {});
//       dispatch(
//         setCartCount(res?.data?.data?.cartData?.length || 0)
//       );
//     } catch (error) {
//       console.error("Error fetching cart details", error);
//     }
//   }, [userId, dispatch]);

//   /* ================================
//      GLOBAL CONFIG
//   ================================= */
//   const fetchGlobalConfig = useCallback(async () => {
//     try {
//       const res = await apiGET(`/v1/global-config/get-config`);
//       if (res.status) {
//         setGlobalConfig(res?.data?.data?.data?.[0] || {});
//       } else {
//         toast.error("Error fetching global config");
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Error fetching global config");
//     }
//   }, []);

//   /* ================================
//      HOME DATA FETCHERS
//   ================================= */
//   const fetchKidenyTopRatedData = useCallback(async () => {
//     try {
//       const res = await apiGET(
//         `${API_URL}/v1/product/getTopRatedProducts`
//       );
//       setKidenyTopRatedData(res?.data?.data?.product || []);
      
//     } catch (error) {
//       console.error("Top rated error:", error);
//     }
//   }, []);

//   const fetchBrandData = useCallback(async () => {
//     try {
//       const payload = { page: 1, limit: 10, searchQuery: "" };
//       const res = await apiPOST(`${API_URL}/v1/brand/all`, payload);
//       setBrandData(res?.data?.data?.brands || []);
//     } catch (error) {
//       console.error("Brand fetch error:", error);
//     }
//   }, []);

//   const fetchProductsBasedOnCategories = useCallback(async () => {
//     try {
//       const res = await apiGET(
//         `${API_URL}/v1/product/getProductsBasedOnCategories`
//       );
//       if (res?.data?.status) {
//         setProductsBasedOnCategoriesData(res?.data?.data || []);
//       }
//     } catch (error) {
//       console.error("Category product error:", error);
//     }
//   }, []);

//   const fetchBannerData = useCallback(async () => {
//     try {
//       const res = await apiGET(
//         `${API_URL}/v1/bannerImg/get-all-banner-img`
//       );
//       setBannerData(res?.data?.data?.data || []);
//     } catch (error) {
//       console.error("Banner fetch error:", error);
//     }
//   }, []);

//   const fetchKidneyMedicinesData = useCallback(async () => {
//     try {
//       const payload = { sortIndex: "", limit: 8, page: 1 };
//       const res = await apiPOST(
//         `${API_URL}/v1/product/getAllProducts`,
//         payload
//       );
//       if (res?.data?.status) {
//         setKidneyMedicinesData(res?.data?.data?.product || []);
//       }
//     } catch (error) {
//       console.error("Kidney medicine error:", error);
//     }
//   }, []);

//   /* ================================
//      FETCH ALL (MAIN)
//   ================================= */
//   const fetchAllData = useCallback(async () => {
//     setLoading(true);
//     await Promise.all([
//       getUserStepperProgress(),
//       fetchGlobalConfig(),
//       fetchKidenyTopRatedData(),
//       fetchBrandData(),
//       fetchProductsBasedOnCategories(),
//       fetchBannerData(),
//       fetchKidneyMedicinesData(),
//     ]);
//     setLoading(false);
//   }, [
//     getUserStepperProgress,
//     fetchGlobalConfig,
//     fetchKidenyTopRatedData,
//     fetchBrandData,
//     fetchProductsBasedOnCategories,
//     fetchBannerData,
//     fetchKidneyMedicinesData,
//   ]);

//   /* ================================
//      INITIAL LOAD
//   ================================= */
//   useEffect(() => {
//     fetchAllData();
//   }, [fetchAllData]);

//   /* ================================
//      UI
//   ================================= */
//   return (
//     <div>
//       <div className="container mx-auto px-4">

//         {loading ? (
//           <div className="mt-20 flex justify-center">
//             <CustomLoader height="h-10" width="w-10" />
//           </div>
//         ) : (
//           <>
//             <MainSlider/>
//             <KidenyTopRated
//               products={kidenyTopRatedData}
//               globalConfig={globalConfig}
//               stepperProgressCartData={stepperProgressCartData}
//               setStepperProgressCartData={setStepperProgressCartData}
//             />

//             <Banner bannerImages={bannerData} />

          
//             <TopUnaniKidneyCareRated
//               data={productsBasedOnCategoriesData}
//               globalConfig={globalConfig}
//               stepperProgressCartData={stepperProgressCartData}
//               setStepperProgressCartData={setStepperProgressCartData}
//             />

//             <Brand brands={brandData} />

//             <KidneyMedicines
//               products={kidneyMedicinesData}
//               globalConfig={globalConfig}
//               stepperProgressCartData={stepperProgressCartData}
//               setStepperProgressCartData={setStepperProgressCartData}
//               refreshProducts={fetchKidneyMedicinesData}
//             />
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Home;


import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import Brand from "../components/topBrand/brand";
import MainSlider from "../components/Banner/MainSlider";
import KidenyTopRated from "../components/TopRatedComponent/KidenyTopRated";
import TopUnaniKidneyCareRated from "../components/TopUnaniKidneyCare/TopUnaniKidneyCareRated";
import Banner from "../components/Banner/Banner";
import KidneyMedicines from "../components/kidneyMedicines/KidneyMedicines";
import CustomLoader from "../components/Loader/CustomLoader";

import { apiGET, apiPOST } from "../utilities/apiHelpers";
import { setCartCount } from "../redux/users/users";
import { API_URL } from "../config";

const Home = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user?.userData?.id) || "";

  const [stepperProgressCartData, setStepperProgressCartData] = useState({});
  const [kidenyTopRatedData, setKidenyTopRatedData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [productsBasedOnCategoriesData, setProductsBasedOnCategoriesData] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [kidneyMedicinesData, setKidneyMedicinesData] = useState([]);
  const [globalConfig, setGlobalConfig] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔥 Trigger for re-fetching KidneyMedicines after cart changes
  const [productRefreshKey, setProductRefreshKey] = useState(0);
  const triggerProductRefresh = () => setProductRefreshKey((prev) => prev + 1);

  /* ================================
     USER STEPPER / CART
  ================================= */
  const getUserStepperProgress = useCallback(async () => {
    if (!userId) return;

    try {
      const res = await apiGET(
        `${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`
      );
      setStepperProgressCartData(res?.data?.data || {});
      dispatch(setCartCount(res?.data?.data?.cartData?.length || 0));
    } catch (error) {
      console.error("Error fetching cart details", error);
    }
  }, [userId, dispatch]);

  /* ================================
     GLOBAL CONFIG
  ================================= */
  const fetchGlobalConfig = useCallback(async () => {
    try {
      const res = await apiGET(`/v1/global-config/get-config`);
      if (res.status) {
        setGlobalConfig(res?.data?.data?.data?.[0] || {});
      } else {
        toast.error("Error fetching global config");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching global config");
    }
  }, []);

  /* ================================
     HOME DATA FETCHERS
  ================================= */
  const fetchKidenyTopRatedData = useCallback(async () => {
    try {
      const res = await apiGET(`${API_URL}/v1/product/getTopRatedProducts`);
      setKidenyTopRatedData(res?.data?.data?.product || []);
    } catch (error) {
      console.error("Top rated error:", error);
    }
  }, []);

  const fetchBrandData = useCallback(async () => {
    try {
      const payload = { page: 1, limit: 10, searchQuery: "" };
      const res = await apiPOST(`${API_URL}/v1/brand/all`, payload);
      setBrandData(res?.data?.data?.brands || []);
    } catch (error) {
      console.error("Brand fetch error:", error);
    }
  }, []);

  const fetchProductsBasedOnCategories = useCallback(async () => {
    try {
      const res = await apiGET(`${API_URL}/v1/product/getProductsBasedOnCategories`);
      if (res?.data?.status) {
        setProductsBasedOnCategoriesData(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Category product error:", error);
    }
  }, []);

  const fetchBannerData = useCallback(async () => {
    try {
      const res = await apiGET(`${API_URL}/v1/bannerImg/get-all-banner-img`);
      setBannerData(res?.data?.data?.data || []);
    } catch (error) {
      console.error("Banner fetch error:", error);
    }
  }, []);

  const fetchKidneyMedicinesData = useCallback(async () => {
    try {
      console.log("🔥 fetchKidneyMedicinesData called");
      const payload = { sortIndex: "", limit: 8, page: 1 };
      const res = await apiPOST(`${API_URL}/v1/product/getAllProducts`, payload);
      if (res?.data?.status) {
        setKidneyMedicinesData(res?.data?.data?.product || []);
      }
    } catch (error) {
      console.error("Kidney medicine error:", error);
    }
  }, []);

  /* ================================
     FETCH ALL (MAIN)
  ================================= */
  const fetchAllData = useCallback(async () => {
    setLoading(true);
    await Promise.all([
      getUserStepperProgress(),
      fetchGlobalConfig(),
      fetchKidenyTopRatedData(),
      fetchBrandData(),
      fetchProductsBasedOnCategories(),
      fetchBannerData(),
      fetchKidneyMedicinesData(),
    ]);
    setLoading(false);
  }, [
    getUserStepperProgress,
    fetchGlobalConfig,
    fetchKidenyTopRatedData,
    fetchBrandData,
    fetchProductsBasedOnCategories,
    fetchBannerData,
    fetchKidneyMedicinesData,
  ]);

  /* ================================
     INITIAL LOAD + REFRESH AFTER CART ACTIONS
  ================================= */
  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  // Re-fetch kidney medicines whenever productRefreshKey increments
  useEffect(() => {
    fetchKidneyMedicinesData();
  }, [fetchKidneyMedicinesData, productRefreshKey]);

  /* ================================
     UI
  ================================= */
  return (
    <div>
      <div className="container mx-auto px-4">
        {loading ? (
          <div className="mt-20 flex justify-center">
            <CustomLoader height="h-10" width="w-10" />
          </div>
        ) : (
          <>
            <MainSlider />
            <KidenyTopRated
              products={kidenyTopRatedData}
              globalConfig={globalConfig}
              stepperProgressCartData={stepperProgressCartData}
              setStepperProgressCartData={setStepperProgressCartData}
              refreshProducts={triggerProductRefresh}
            />
            <Banner bannerImages={bannerData} />
            <TopUnaniKidneyCareRated
              data={productsBasedOnCategoriesData}
              globalConfig={globalConfig}
              stepperProgressCartData={stepperProgressCartData}
              setStepperProgressCartData={setStepperProgressCartData}
              refreshProducts={triggerProductRefresh}
            />
            <Brand brands={brandData} />
            <KidneyMedicines
              products={kidneyMedicinesData}
              globalConfig={globalConfig}
              stepperProgressCartData={stepperProgressCartData}
              setStepperProgressCartData={setStepperProgressCartData}
              refreshProducts={triggerProductRefresh}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
